// A number input paired with an "Unlimited" checkbox — the shared control
// for admin per-tenant / per-tier caps. `null` = unlimited, a number = an
// explicit cap. Used for broadcast cadence and staff seats.

export function CapField({
  id,
  label,
  hint,
  value,
  onChange,
  min,
  max,
  fallbackOnUncheck,
}: {
  id: string
  label: string
  hint: string
  value: number | null
  onChange: (v: number | null) => void
  min: number
  max: number
  /** Number to restore when the user unchecks "Unlimited". */
  fallbackOnUncheck: number
}) {
  const isUnlimited = value === null
  return (
    <div className="admin-field">
      <label className="admin-label" htmlFor={id}>
        {label}
      </label>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <input
          id={id}
          type="number"
          min={min}
          max={max}
          className="admin-input"
          style={{ maxWidth: 120 }}
          value={isUnlimited ? '' : value}
          disabled={isUnlimited}
          onChange={(e) => {
            const raw = e.target.value
            onChange(raw === '' ? null : Number(raw))
          }}
        />
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            cursor: 'pointer',
          }}
        >
          <input
            type="checkbox"
            checked={isUnlimited}
            onChange={(e) =>
              onChange(e.target.checked ? null : fallbackOnUncheck)
            }
          />
          <span>Unlimited</span>
        </label>
      </div>
      <p className="admin-hint">{hint}</p>
    </div>
  )
}
